import { render, staticRenderFns } from "./BatchModifyStock.vue?vue&type=template&id=523a93b8&scoped=true"
import script from "./BatchModifyStock.vue?vue&type=script&lang=js"
export * from "./BatchModifyStock.vue?vue&type=script&lang=js"
import style0 from "./BatchModifyStock.vue?vue&type=style&index=0&id=523a93b8&prod&scoped=true&lang=css"
import style1 from "./BatchModifyStock.vue?vue&type=style&index=1&id=523a93b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523a93b8",
  null
  
)

export default component.exports